import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'

const Button = styled.button`
  background: #00000015;
  border: 0;
  color: #111;
  padding: 10px 12.5px;
  border-radius: 4px;
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;

  span:nth-child(1) {
    padding-right: 5px;
  }

  &:hover {
    background: #333;
    color: white;
  }
`

export default ({ posts }) => {
  const { previous, next } = posts
  const hasPost = previous || next
  return (
    hasPost && (
      <div className='level'>
        <div className='level-item' style={{ height: '100px', marginTop: '-5vw' }}>
          {previous && (
            <Link to={`/blog/${previous.titleSlug}`}>
              <Button className='prev-post btn' style={{ margin: '0 15px' }}>
                <span role='img' aria-label='finger pointing left'>
                  👈
                </span>
                <span>Previous Post</span>
              </Button>
            </Link>
          )}
          {next && (
            <Link to={`/blog/${next.titleSlug}`}>
              <Button className='next-post btn' style={{ margin: '0 15px' }}>
                <span>Next Post </span>
                <span role='img' aria-label='finger pointing right'>
                  👉
                </span>
              </Button>
            </Link>
          )}
        </div>
      </div>
    )
  )
}
